module.exports = __webpack_public_path__ + "static/media/stop.e37de6c7.svg";